import EEPlaceholder from 'components/Sections/EEPlaceholder';
import { useSitecoreContext } from 'hooks/useSitecoreContext';
import useHelpers from 'hooks/helpers';
import FundsListing from 'components/Pages/FundsCenter/AllFunds/FundsListing/FundsListing';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { fundCentreActions } from '@/store/fundCentre';

const StrategyInFocus = ({ fields, rendering, allFundsTabTabs }): JSX.Element => {
  const { sitecoreContext } = useSitecoreContext();
  const { anchorId } = useHelpers(rendering);
  const {
    fundCentreConfiguration: {
      countryInvestors: { countryCode, investorType, jurisdiction, literatureAuthorization },
    },
    site: { name },
  } = sitecoreContext;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      fundCentreActions.setFilters([
        {
          name: fields.strategyInFocus.value.filterName,
          values: fields.strategyInFocus.value.filterValues,
        },
      ])
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return sitecoreContext.pageEditing ? (
    <EEPlaceholder>Strategy in focus</EEPlaceholder>
  ) : (
    <section id={anchorId} data-e2e-component-uid={rendering.uid}>
      <FundsListing
        itemsPerPage={20}
        jurisdiction={jurisdiction}
        filters={[]}
        investorType={investorType}
        countryCode={countryCode}
        literatureAuthorization={literatureAuthorization}
        withFilters={false}
        withPagination={false}
        site={name}
        allFundsTabTabs={allFundsTabTabs}
      />
    </section>
  );
};

export default StrategyInFocus;
